import { ExclamationCircleSolid, Text, TextProps } from '@bonusly/design-system';

export const ErrorMessage = ({ children, ...rest }: TextProps) => {
	return (
		<Text display="flex" alignItems="center" color="error.text" fontSize={50} lineHeight={5} {...rest}>
			<ExclamationCircleSolid size="md" color="error.icon" pr={1} />
			{children}
		</Text>
	);
};
